import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  templateUrl: './sidebar.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatListModule,
    MatIconModule,
    RouterModule
  ],
})
export class SidebarComponent {
  @Input() username: string = '';

  panels = [
    {
      title: 'Processos',
      icon: 'folder',
      links: [
        { path: '/implantacao', label: 'Implantação', icon: 'home' },
        { path: '/estatisticas', label: 'Implantação Municípios JUCEMG', icon: 'bar_chart' },
      ],  
      expanded: false,
    },
    {
      title: 'Documentos e Comunicados',
      icon: 'description',
      links: [
        { path: '/documents-issued', label: 'Documentos emitidos', icon: 'insert_drive_file' },
      ],  
      expanded: false,
    },
    {
      title: 'Cadastros',
      icon: 'description',
      links: [
        { path: '/unidades', label: 'Unidades', icon: 'home' },
        { path: '/usuarios', label: 'Usuários Administrativos', icon: 'people' },
        { path: '/empresas-cidadaos', label: 'Empresas/Cidadãos', icon: 'business' },
        { path: '/imoveis', label: 'Imóveis', icon: 'apartment' },
      ],
      expanded: false,
    },
    {
      title: 'Cobranças',
      icon: 'attach_money',
      links: [
        { path: '/taxas-guias', label: 'Taxas/Guias Emitidas', icon: 'receipt' },
      ],
      expanded: false,
    },
    {
      title: 'Atendimento',
      icon: 'support-agent',
      links: [
        { path: '/fale-conosco', label: 'Fale Conosco', icon: 'chat' },
      ],
      expanded: false,
    },
  ];
}